// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 5619) return "static/chunks/5619.b2cc488925fcf795.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"3371":"507c6a3d8823d6bd","3679":"9cdc2a8658f30be8","4386":"bc200ecd2e338187","5156":"9e000cc0fc28ebcb"}[chunkId] + ".js";
};